import loadable from '@loadable/component';
import type * as React from 'react';
import type { SliderModal } from '@cian/frontend-newbuilding-promo-modal-widget';

export type TSliderModalProps = React.ComponentProps<typeof SliderModal>;

export const SliderModalLoadable = loadable<TSliderModalProps>(() => {
  if (process.env.IS_BROWSER_BUILD) {
    return import('@cian/frontend-newbuilding-promo-modal-widget')
      .then(({ SliderModal }) => ({ default: SliderModal }))
      .catch(
        /* istanbul ignore next */
        () => ({ default: () => null }),
      );
  }

  return Promise.resolve({
    default: () => null,
  });
});
